import * as React from "react";
import "./Layout.css";
import Helmet from "react-helmet";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";

const favicon =
  "data:image/svg+xml,<svg xmlns=%22http://www.w3.org/2000/svg%22 width=%22256%22 height=%22256%22 viewBox=%220 0 100 100%22><rect width=%22100%22 height=%22100%22 rx=%2220%22 fill=%22%23000000%22></rect><path fill=%22%23fff%22 d=%22M77.52 23.23L66.20 76.77L53.68 76.77L40.64 36.27L40.28 36.27L39.98 38.43Q39.00 46.26 37.86 51.57L37.86 51.57L32.55 76.77L22.48 76.77L33.80 23.23L46.87 23.23L59.32 62.67L59.61 62.67Q60.89 54.50 62.10 48.57L62.10 48.57L67.49 23.23L77.52 23.23Z%22></path></svg>";

class Layout extends React.Component {
  render() {
    return (
      <div className="main-body w-full max-w-full m-0 p-0">
        <Helmet htmlAttributes={{ lang: "en" }}>
          <meta charset="UTF-8" />
          <meta
            name="viewport"
            content="height=device-height, width=device-width,
    initial-scale=1.0, minimum-scale=1.0, maximum-scale=5.0"
          />
          <meta
            name="description"
            content="We build robots as per your requirements. We have expertise in Mechanical Design, Embedded, Circuit and PCB Design, Software (Robot Operating System) and App Development."
          />
          {/* <title>Nawe Robotics</title> */}
          <meta
            name="keywords"
            content="Custom robotics solutions, High Torque Motors, High Torque actuators, High Torque Density actuators, High torque brushless motor, Custom Motors"
          />
          <meta name="robots" content="index, follow" />
          <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
          <meta name="language" content="English" />

          <link rel="icon" href={favicon} />
        </Helmet>
        <Header />
        {this.props.children}
        <Footer />
      </div>
    );
  }
}

export default Layout;
